<template>
  <header
    id="header"
    class="header"
    :class="headerClasses || ''"
  >
    <div class="header__wrapper">
      <div
        v-if="isMobile && !isBurgerRight"
        class="header__menu"
        :class="{ active: navMenu }"
        @click="toggleMobileMenu"
      >
        <span class="header__menu-btn"></span>
      </div>
      <Logo />
      <ChangeLanguage />
      <div class="header__contacts">
        <div
          class="header__contacts-link header__contacts-link--decorated"
          @click="logout"
        >
          <svg
            class="header__contacts-link-pic"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- eslint-disable -->
            <path
              d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <!-- eslint-enable -->
            <path
              d="M16 17L21 12L16 7"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21 12H9"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div
        v-if="isMobile && isBurgerRight"
        class="header__menu header__menu--decorated"
        :class="{ active: navMenu }"
        @click="toggleMobileMenu"
      >
        <span class="header__menu-btn"></span>
      </div>
    </div>
    <section
      v-if="navMenu"
      class="header__navbar"
    >
      <div class="header__navbar-menu">
        <nav class="navbar__section">
          <ul
            class="navbar__list a-font__nav"
            :class="{ 'no-margin-last-child': !hasActivePhysicalUserCard }"
          >
            <li
              v-for="(item, index) in navbarItems"
              :key="index"
              class="navbar__item"
              @click="navMenu = false"
            >
              <router-link
                :key="index"
                class="navbar__link"
                :class="{ main: index === 0 }"
                :to="item.path"
              >
                {{ $t(item.title) }}
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </section>
    <BaseDialog
      v-model="showInvitation"
      close
    >
      <PInvitation @close="popupClose" />
    </BaseDialog>
    <BaseDialog
      v-model="tokenOut"
      close
    >
      <section class="navbar__popup">
        <h3 class="a-font__h3">
          Пока не работает =(
        </h3>
        <p class="a-font__l">
          Данная функция вскоре будет доступна 😇
        </p>
      </section>
    </BaseDialog>
  </header>
</template>

<script lang="ts">
import PInvitation from '@/projects/people/components/popups/p_invitation/p_invitation.vue';
import { useKeycloak } from '@/shared/_domains/keycloak/modules/useKeycloak';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import { showInvitation } from '@/shared/states/invitation';
import { useUiStore } from '@/shared/store/useUiStore';
import { useUserStore } from '@/shared/store/useUserStore';
import {
  useRouter,
} from '@intlify/vue-router-bridge';
import {
  computed,
  defineComponent,
} from 'vue';
import ChangeLanguage from './ChangeLanguage.vue';
import Logo from './Logo.vue';

export default defineComponent({
  name: 'AppHeader',
  components: {
    BaseDialog,
    ChangeLanguage,
    Logo,
    PInvitation,
  },
  setup(_props) {
    const userStore = useUserStore();
    const uiStore = useUiStore();
    const { hasActivePhysicalUserCard } = userStore;
    const $router = useRouter();
    const routerItems = $router.options.routes || [];
    const headerClasses = computed(() => uiStore.headerClasses) || '';
    const navbarItems = routerItems.filter(
      // @ts-ignore
      item => item.isInNavbar && (item?.isAllowWithoutUserCard ? true : !!hasActivePhysicalUserCard),
    );

    const { logout } = useKeycloak();

    return {
      showInvitation,
      logout,
      headerClasses,
      hasActivePhysicalUserCard,
      navbarItems,
    };
  },

  data: () => ({
    isMobile: false,
    navMenu: false,
    visible: false,
    tokenOut: false,
  }),
  computed: {
    isBurgerRight() {
      return !!this.headerClasses.split(' ').filter((el: string) => el === 'burger-right').length || false;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('DOMContentLoaded', this.handleResize);
    this.handleResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('DOMContentLoaded', this.handleResize);
  },

  methods: {
    toggleMobileMenu() {
      this.navMenu = !this.navMenu;
    },

    handleResize() {
      const windowWidth = window.innerWidth;
      this.isMobile = windowWidth < 768;
    },
    popupClose() {
      this.visible = false;
      this.tokenOut = false;
      this.navMenu = false;
      showInvitation.value = false;
    },
  },
});
</script>

<style lang="scss" src="./TheHeader.scss"></style>
